<template>

<div class="table-header">
  <v-card class="cardDocs">
      <v-card-title>
        <h1 class="titleTable">{{component.text.length > 0 ? component.text : ''}}</h1>
      </v-card-title>

        <v-dialog @keydown.esc="dialogPDF = false"
          v-model="dialogPDF"
          fullscreen
          :lazy="true"
          >
          <v-card>
            <v-card-title
              class="headline darkBlue"
              text-color="white"
              style="color: white;"
            >
              {{iptuName}}
              <v-spacer></v-spacer>
              <v-btn icon dark @click.native="dialogPDF = false">
                  <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text id="tst">
                <iframe style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.danfe)" frameborder="0"/> 
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogPDF = false">
                  Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div id="fileManager">
          <div class="treeFolders" id="treeview">
            <v-treeview
              v-model="selectedPasta"
              :open.sync="open"
              activatable
              :active="active"
              :items="this.root"
              item-text="nome"
              item-key="idPasta"
              open-on-click
              transition
              id="treeview-id"
            >
              <template v-slot:prepend="{ item, open }">
                  <v-icon color="teal" v-if="!item.file" >
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                
              </template>
              <template v-slot:append="{ item, open }" id="nodeId">
                {{ open || item.root ? handleOpenFolder(item, open) : handleCloseFolder(item, open) }}
              </template>
              
            </v-treeview>
            
          </div>
          <div class="treeFiles" >
      
          <v-card v-if="this.lastExpandedFolder.name">
            
            <v-card class="filesMenu" >
              <div class="breadcrumbs">
                <div :key="folder.id" v-for="folder in this.bread">
                  <span :class="[ bread[bread.length -1] !== folder ? ' notCurrentFolder breadcrumbsItem' : 'breadcrumbsItem' ]" :id="folder.id" @click="handleBreadcrumbs($event)"> {{ folder.text }} </span>
                  <span class="breadcrumbsSeparator"> / </span>
                  
                </div>
              
            </div>
            </v-card>

            <v-card-title class="documentsTableTitle">

              <!-- <UploadFile :component="this.component" v-if="lastExpandedFolder.parentId" @updateFileList="updateFileList($event)"></UploadFile> -->
              <v-text-field
                v-model="search"
                label="Pesquisar"
                class="fileSearchField "
                append-icon="search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            
            <v-data-table

              :headers="headers"
              :items="fileItems"
              :search="search"
              :next="$vuetify.icons.next"
              :loading="false"
              :rows-per-page-items="pagination.rowsPerPageItems"
              :pagination.sync="pagination"
              id="table"
              class="docsFederalTable elevation-1"
              
              prev-icon
              next-icon
              item-key="idDocumento"
              rows-per-page-text="Arquivos por página:"
            >
            
            <template slot="no-data">
              <v-alert :value="true" color="indigo darken-4" icon="info" outline>
                <article >
                  <strong>O diretório não possui arquivos.</strong>
                </article>
              </v-alert>
            </template>

            <v-progress-linear slot="progress" color="teal" height="20" indeterminate style="z-index: 3;"></v-progress-linear>
            <template v-slot:headers="props">
             <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon color="white" small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
              </tr>
            </template>


            
              <template slot="items" slot-scope="props">
                <tr :active="props.selected" @click="props.selected = !props.selected" class="tdCheckbox">

                <td style="padding:0 4px">
                  <div class="actionsDisplay">                  
                    <div style="display: inline-block;">
                     
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                      <v-btn icon  style="margin:0;color:grey" v-on="on" :disabled="!disableButton(props.item.nome)" :class="[disableButton(props.item.nome) ? '' : 'btnDisabled']">
                      <v-icon style="font-size: 16px" small aria-hidden="true"  :class="[disableButton(props.item.path) ? 'editIcon' : 'editIcon c_disabled']" @click="getDanfe(props.item.idImovel, props.item.idDocumento, props.item.nome)">remove_red_eye</v-icon>
                      </v-btn>
                      </template>
                      <span>Visualizar documento</span>
                    </v-tooltip>
                    </div>
                    <div style="display: inline-block;">
                      <a id="dLinkPdf">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="light-blue darken-4"
                            icon
                            small
                            flat
                            style="margin-left:-5px"
                            @click="setDanfe(props.item.idImovel, props.item.idDocumento, props.item.nome)"
                          >
                            
                            <svg class="customIcon i_action" viewBox="0 0 24 24">
                              <path
                                fill="#000000"
                                d="M14,9H19.5L14,3.5V9M7,2H15L21,8V20A2,2 0 0,1 19,22H7C5.89,22 5,21.1 5,20V4A2,2 0 0,1 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z"
                              />
                            </svg>
                          </v-btn>
                          <span>
                            Baixar documento
                          </span>
                        </v-tooltip>
                      </a>
                    </div>
                  </div>
                </td>
                <td>{{ props.item.nome }}</td>
                
                <td>{{ props.item.dataIni }}</td>
                <td>{{ props.item.dataMod }}</td>
                
                </tr>
              </template>
              <template slot="pageText" slot-scope="props">
                <strong>
                  Exibindo {{ props.pageStart }} - {{ props.pageStop }} do total de {{ quantity }}
                  <span>{{ quantity === 1 ? 'Arquivo' : 'Arquivos' }}</span>
                </strong>.
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua pesquisa por "{{ search }}" não tem resultados.</v-alert>
            </v-data-table>



            <div class="text-xs-center pt-2 btn_pages" id="pagination_button">
              <v-pagination v-model="pagination.page" color="teal" :length="this.fileList ? paginationNumber : 1"></v-pagination>
            </div>
            </v-card>

            <v-card v-else-if="this.root.length == 0">
              <span style="color:red;">Não foi encontrado nenhum diretório</span>
            </v-card>  

            <v-card v-else>
              <span>Por favor selecione um diretório</span>
            </v-card> 
          </div>
        </div>


        
  </v-card>
</div>
</template>

<script>
import TreeBrowser from './TreeBrowser/TreeBrowser';

import DocumentosService from '@/domain/documentos/Documentos';
import IptuService from "@/domain/automacaoFiscal/iptu/IptuService";
import NfeService from "@/domain/notas/nfe/NfeService";
import UploadFile from '@/components/shared/uploadFile/UploadFile';
import NfseService from "@/domain/notas/nfse/NfseService";

export default {

  props: ["conta","empresa", "alert", 'IBGE', 'component'],
  data() {
    return {
      imoveisList: [],
      fileItems: [],
      currentNode: '',
      root: [],
      dialog: false,
      dialogRenomearArquivo: false,
      dialogPDF: false,
      danfe: null,
      download: null,
      selectedItem: '',
      headers: [
        { text: 'Ações', align: 'center', value: 'actions' },
        { text: 'Nome', align: 'center', height: '37', value: 'nome' },
        { text: 'Data de inclusão', align: 'center', value: 'insertDate' },
        { text: 'Ultima atualização', align: 'center',  value: 'dateUpdate' },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        createdBy: '',
        dateUpdate: '',
      },
      search: '',
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 30 , 50],
        sortBy: 'nome',
      },
      items: [
        {
          title: "PDF",
          tooltip: "Baixar apenas PDF das notas selecionadas",
          icon: "",
          evento: "pdf"
        },
      ],
      open: [],
      active: [],
      selectedPasta: [],
      fileList: [],
      formatedJson: [],
      bread: [],
      nodeChildren: [],
      tamanho: '',
      dataIni: '',
      dataMod: '',
      nomeDoc: '',
      iptuName: '',
    }
  },
  mounted() {
    this.handleTreeView();
  },
  watch: {
    empresa(newV, oldV) {
      if(newV._id != oldV._id) {
        const changePage = newV.servicos ? newV.servicos.robotizacao.find(item => item.nomeServico == "IPTU"): null;
        if(!changePage){
          this.$router.push('/DashBoard');
          return;
        }else {
          this.handleTreeView();
        }
      }
    }
  },

  methods: {
    handleTreeView() {
      this.imoveisList = [];
      this.formatedJson = [];
      let service = new DocumentosService(this.$http);
      let iptuService = new IptuService(this.$http);
      this.activeGlobalLoader();
      iptuService.getImoveis(0, 0,this.empresa._id).then(imoveis => {
        service.getDocsFederal(imoveis).then((json) => {
        this.imoveisList.push(json);
        service.convertJson(json).then(json => {
          this.root = json;
          this.desactiveGlobalLoader();
        })
        
      });
    })
    
    // service.getDbData(this.imoveisList).then(response => {
      this.formatedJson.push(this.imoveisList);
      this.$store.commit('addMongoFolderReturn', this.imoveisList);
    // });
    },
    updateFileList() {
      this.fileItems = this.files;
    },
    getDanfe: async function(idImovel, idIptu, name) {
      this.iptuName = name;
      let service = new DocumentosService(this.$http);
      await service.getIptu(idImovel, idIptu).then(file => {
        this.danfe = file;
        if (this.danfe != null) {
          this.dialogPDF = true;
        }
      });
    },
    setDanfe: async function(idImovel, idIptu, fileName) {
        let service = new DocumentosService(this.$http);
        await service.getIptu(idImovel, idIptu).then(file => {
          this.download = file;
          this.setDownload(fileName);
        });  
    },
    setDownload: function(fileName) {
      var a = document.querySelector("#dLinkPdf");
      a.setAttribute(
        "href",
        "data:application/pdf;base64," + encodeURIComponent(this.download)
      );

      a.setAttribute("download", fileName);
      a.click();
      a.removeAttribute("href");
      a.removeAttribute("download");

      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    },
    setDownloadXml: function() {
      // var a = document.querySelector("#dLinkPdf");
      // a.setAttribute(
      //   "href",
      //   "data:text/plain;charset=utf-8," + encodeURIComponent(this.download)
      // );
      // console.log(this.nomeDoc);
      // let nome = this.component.tipo + '_novembro';
      // if(this.editedItem.nome) {
      //   nome = this.editedItem.nome;
      // }
      // a.setAttribute("download", nome + ".csv");
      // a.click();
      // a.removeAttribute("href");
      // a.removeAttribute("download");

      let csvContent = atob(this.download);
      var blob = new Blob([csvContent], {type: "data:application/octet-stream;base64"});
      var url  = window.URL.createObjectURL(blob);
      // you need to precise a front-end button to have a name
      var dlnk = document.querySelector("#dLinkPdf");
      dlnk.href = url;
      let nome = this.nomeDoc;
      if(this.editedItem.nome) {
        nome = this.editedItem.nome;
      }
      dlnk.setAttribute("download", this.nomeDoc);
      dlnk.click();
      dlnk.removeAttribute("href");
      dlnk.removeAttribute("download");





      // :href="'data:application/pdf;base64,'+ encodeURIComponent(this.nota.item.danfe)" :download="this.nota.item.chave+'.pdf'"
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    disableButton: function(fileName) {
      if(fileName && fileName.includes('pdf')) {
        return true;
      }else {
        return false;
      }
    },
    changeSort (column) {
      console.log('changeSort');
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    handleBreadcrumbs(e) {
      let activeNode = {};
      if(this.bread) {
        this.bread.map(node => {
          if(node.id == e.target.id) {
            activeNode = node;
            // this.handleFocus(e.target.innerText);
          }
        })
      }
      this.montaArvoreSelecionada(activeNode.id).then(folderList => {
        let auxList = [];
        this.nodeChildren = [];
        if(folderList.length) {
          folderList.length = folderList.length;
        
          folderList.map((item, index) => {
            auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
            if(folderList.length -1 === index){

              this.findChildren(item.idPasta).then(() => {
                this.fileList = this.nodeChildren;
                if(this.fileList.length) {
                  this.$store.commit('addFiles', this.fileList);
                  this.fileItems = this.fileList;
                }else {
                  const json = (this.formatedJson);
                  const parent = json[0][0].find(pasta => pasta.idPai === item.idPasta);
                  if(parent) {
                    this.$store.commit('addLastExpandedFolder', { name: parent.nome, id: parent.idPasta, parentId: undefined, origin: parent.origin, children: parent.children });
                    this.fileList = [];
                    this.$store.commit('resetFiles');
                    this.fileItems = [];
                  }
                }
              });
            }
          });
          this.bread = auxList;
        }
      });      
    },
    setFile(e) {
      this.file = e.target.files;
    },
    
    async findChildren(nodeId, children=null) {
      this.root.map(node => {
        let obj = node;

        if(children) {
          obj = children;
        }

        if( obj.idPasta === nodeId ){
          if(obj.arquivos) {
            this.nodeChildren = obj.arquivos;
          }
          
          return true;
        }
        if(obj.children) {
          obj.children.map(child => {
            
            this.findChildren(nodeId, child);
          });
        }
        
        return false;

      });
    },
    async pushFiles(node) {
       if(node.arquivos) {
         return node.arquivos;
       }else {
         return [];
       }
    },
    handleOpenFolder(item, open) {
      if(!open) {
        this.$store.commit('addLastExpandedFolder', { name: '', id: '', parentId: '', origin: '', children: [], });
        return '';
      }
      
      // let treeview = document.querySelectorAll('#treeview-id .v-treeview-node__content');
      // let icon = document.querySelectorAll('#treeview-id .v-treeview-node__content i');
      // let label = document.querySelectorAll('#treeview-id .v-treeview-node__content .v-treeview-node__label');
      // if(treeview.length > 1) {
      //   for(let i=0; i<treeview.length; i++) {
      //     if(treeview[i].innerText !== item.nome && treeview[i].innerText.includes('-')) {
      //       treeview[i].classList.remove('openedFolder');
      //     }else if(treeview[i].innerText === item.nome && treeview[i].innerText.includes('-')) {
      //       treeview[i].classList.add('openedFolder');
      //       icon[i].classList.add('openedFolderIcon')
      //     }
      //   }
      // }

      // this.handleFocus(item.idPasta);
      
      this.montaBreadCrumbs(item.idPasta);
      this.$store.commit('addLastExpandedFolder', { name: item.nome, id: item.idPasta, parentId: item.idPai, origin: item.origin, children: item.children });
      this.pushFiles(JSON.parse(JSON.stringify(item)))
        .then(files => {
          this.fileList = files;
          this.$store.commit('resetFiles');
          this.fileItems = [];
          files.map(file => {
            this.$store.commit('addFiles', file);
            this.fileItems.push(file);
            this.currentNode = item.idPasta;
          });
        })
      return '';
    },
    handleFocus(nodeName) {
      nodeName = nodeName.trim();
      let treeview = document.querySelectorAll('#treeview-id .v-treeview-node__content');
      let icon = document.querySelectorAll('#treeview-id .v-treeview-node__content i');
      let label = document.querySelectorAll('#treeview-id .v-treeview-node__content .v-treeview-node__label');
      
      if(treeview.length > 1) {
        for(let i=0; i<treeview.length; i++) {
          if(treeview[i].innerText != nodeName) {
            treeview[i].classList.remove('openedFolder');
            icon[i].classList.remove('openedFolderIcon');
          }else if(treeview[i].innerText == nodeName && !treeview[i].innerText.includes('20')) {
            treeview[i].classList.add('openedFolder');
            icon[i].classList.add('openedFolderIcon');
          }else {
            treeview[i].classList.add('openedFolder');
            icon[i].classList.add('openedFolderIcon');
          }
        }
      }
    },
    handleCloseFolder(item, open) {
      let activeNode = {};
      if(this.bread) {
        this.bread.map(node => {
          if(node.id == item.idPasta) {    
            activeNode = node;
            const json = (this.formatedJson);
            const parent = json[0][0].find(pasta => pasta.idPasta === item.idPai);
            if(parent) {
              
              this.$store.commit('addLastExpandedFolder', { name: parent.nome, id: parent.idPasta, parentId: parent.idPai, origin: parent.origin, children: parent.children });
              this.fileList = [];
              this.$store.commit('resetFiles');
              this.fileItems = [];
            }
            
          }
        })
      }
      
      this.montaArvoreSelecionada(activeNode.id).then(folderList => {
        let auxList = [];
        if(folderList.length) {
          folderList.length = folderList.length -1;
        
          folderList.map(item => {
            auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
          });
          this.bread = auxList;
          return '';
        }else {
          return '';
        }
        
      });

      return '';
      
    },
    async montaBreadCrumbs(idPasta) {
      let auxList = [];
      const folderList = await this.montaArvoreSelecionada(idPasta);

      folderList.map(item => {
        auxList.push({ text: item.nome, id: item.idPasta, parentId: item.idPai ? item.idPai : "root" });
      });
      
      this.bread = auxList;
    },
    async montaArvoreSelecionada(idPasta, expand = false) {
      let buscaPai = false;
      let idBusca = idPasta;
      const estruturaPastas = [];
      const json = (this.formatedJson);
      if(idBusca != undefined) {
        while (!buscaPai) {
          const pastaAtual = json[0][0].find((pasta) => pasta.idPasta == idBusca);

          if(pastaAtual) {
            estruturaPastas.push(pastaAtual);
            idBusca = pastaAtual.idPai;
            buscaPai = !pastaAtual.idPai;
          }else {
            buscaPai = true;
          }
        }
      }
      return estruturaPastas.reverse();
    },
  },
  components: {
    TreeBrowser,
    UploadFile,
  },
  computed: {
    files() {
      return this.$store.getters.files;
    },
    lastExpandedFolder() {
      return this.$store.state.lastExpandedFolder;
    },
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    },
    paginationNumber() {
      const files = this.fileList.length;
      const rows = this.pagination.rowsPerPage;
      
      if(files <= 10){
        return 1;
      }
      else if ( files >= rows ) {
        return Math.ceil(files / rows, 1);
      } else {
        return Math.ceil(rows / files, 1);
      }
    },
    quantity() {
      return this.fileItems.length;
    },
    mongoFolderReturn() {
      return this.$store.state.mongoFolderReturn;
    },
  },
}
</script>

<style scoped>
body {
  background-color: #333;
  color: white;
}
#fileManager {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 500px;
  /* margin-top: 30px; */
  /* margin-left: 30px; */
  /* margin-right: 30px; */
  display: flex;
  justify-content: space-around;
  max-height: 700px;
  margin-bottom: 20px;
}

.treeFolders {
  width: 35%;
  /* height: 700px; */
  border-right: 2px solid #ccccccc2;
  border-bottom: 2px solid #ccccccc2;
  /* padding-left: 20px; */
  overflow: auto;
  display: flex;
}

.treeFiles {
  font-size: 18px;
  display: flex;
  flex-direction: column;
  width: 65%;
  /* height: 500px; */
  overflow: auto;
  margin-bottom: 10px;
  /* border-left: 2px solid  #ccc; */
  /* border: 4px solid #0000000d; */
  /* cursor: pointer; */
}

.table-header .v-card__title {
  border-top: 2px solid #0000000d;
  border-bottom: 2px solid #0000000d;
}

.cardDocs {
  min-height: 440px;
  /* padding-bottom: 30px; */
}

.buttonsDocsFederal {
  padding-top: 24px;
  padding-bottom: 5px;
}

.listFiles {
  list-style: none;
  align-items: left;
  display: flex;
  margin-bottom: 10px;
}

.docsFederalTable {
  /* max-width: 90%; */
  margin: 0 auto;
  margin-top: 16px;
}

#table table.v-table thead tr {
  height: 33px;
}

.selectRow {
  background: #009688;
  color: #fff;
}

.selectRow:hover {
  background: #009688!important;
  color: #fff;
}

.tableIcons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
.tableIcons i, .tableIcons svg {
  cursor: pointer;
}
.editIcon{
  width: 19.99px;
  height: 19.99px;
  cursor: pointer;
  color: grey;
}
.editIcon:hover {
  color: #009688;
}
.documentsTableTitle {
  display: flex;
  align-items: center;
  /* padding-left: 40px;
  padding-right: 50px; */
  margin-top: -16px;

}

.breadcrumbs {
  display: flex;
  flex-direction: row;
  justify-content: start;
  margin-left: 16px;
}

.breadcrumbsItem {
  font-size: 16px;
  margin-right: 6px;
  color: #1976d2;
  cursor: pointer;
}

.breadcrumbsItem:hover {
  opacity: 1;
}

.breadcrumbsSeparator {
  margin-right: 6px;
  font-size: 16px;
  color: #1976d2;
}

.notCurrentFolder {
  opacity: 0.6;
}

.btnOptions {
  margin-top: -60px;
}

.filesMenu {
  display: flex;
  padding-left: 10px;
  padding-right: 50px;
  justify-content: space-between;
  align-items: center;
  height: 26.92px;
}

.filtroForSearch div.v-input__slot {
  margin-top: 0!important;
}

.filtroForSearch .v-label {
  color: #fff!important;
}

.divBtnOptions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 16px!important;
  width: 116.48px;
  height: 30px;
  border: 2px solid #009688;
  border-radius: 3px;
  cursor: pointer;
  text-align-last:center;
  text-align: center;
  margin-bottom: -20px;
  font-weight: 100;
  will-change: box-shadow!important;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important;
}

.fileSearchField {
    /* border-radius: 10px 10px 10px 10px!important; */
    /* border-left: 1px solid #a9a9a9!important; */
    padding-left: 10px;

}

/* Table styles */
#table table tr {
  white-space: nowrap;
}

#table td, #table th{
  padding: 0 4px;
}

tr:nth-of-type(even) {
    background-color: #e1e1e1;
}

#pagination_button {
  width: 400px;
  margin: 0 auto;
}

.tdAcoes {
  border-right: thin solid #6d7d80!important;
  min-width: 135.8px;
  left: 41px;
  padding-top: 0!important;
  box-shadow: 1px 0 19px #b8b8b899;
  margin-top: -.2px;
}

.headerCheckbox {
  background-color: #6d7d80!important;
  color: #fff!important;
}

.btnDisabled::before {
  content: "";
  position: absolute;
  width: 6%;
  height: 19.5%;
  background-color: red;
  opacity: 0.8;
  border-radius: 0;
  top: unset !important;
  left: unset !important;
  bottom: 10px !important;
  z-index: 2;
  right: 13px !important;
  transform: rotate(45deg);
}

.btnDisabled::after {
  content: "";
  position: absolute;
  width: 6%;
  height: 19.5%;
  background-color: red;
  z-index: 2;
  opacity: 0.8;
  border-radius: 0;
  bottom: 10px !important;
  right: 13px !important;
  transform: rotate(135deg);
}

.actionsDisplay {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: -2px;
  justify-content: center;
}

</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/docsFederal/DocsFederal.vue